import { formatEther, readContract, writeContractAndWait } from "../viem";
import config from "../../config/config";

import MafiaSmuggleMarketAbi from "../../abis/MafiaSmuggleMarket.json";

const address = config.smuggleMarketAddress;
const abi = MafiaSmuggleMarketAbi;

export const getLaunchBlock = async () => {
  const launchBlock: number = await readContract({
    address,
    abi,
    functionName: "launchBlock",
  });
  return Number(launchBlock);
};

export const getUpdateInterval = async () => {
  const updateInterval: number = await readContract({
    address,
    abi,
    functionName: "updateInterval",
  });
  return Number(updateInterval);
};

export const getCityMarketPrice = async (cityId: number) => {
  const cityMarketPrice: any = await readContract({
    address,
    abi,
    functionName: "getCityMarketPrice",
    args: [cityId],
  });
  const boozePrices = cityMarketPrice.boozePrices ?? cityMarketPrice[0] ?? [];
  const narcsPrices = cityMarketPrice.narcsPrices ?? cityMarketPrice[1] ?? [];
  return [boozePrices, narcsPrices].map((price) =>
    price.map((p: string | number | bigint) => Number(formatEther(p)))
  );
};

export const buyBooze = async (
  account: string,
  types: number[],
  signMsg: string,
  signature: string
) => {
  const receipt = await writeContractAndWait({
    address,
    abi,
    functionName: "buyBooze",
    args: [types, JSON.stringify(signMsg), signature],
    account,
    gasMultiplier: 5,
  });

  return receipt.transactionHash;
};

export const sellBooze = async (
  account: string,
  itemIds: number[],
  signMsg: string,
  signature: string
) => {
  const receipt = await writeContractAndWait({
    address,
    abi,
    functionName: "sellBooze",
    args: [itemIds, JSON.stringify(signMsg), signature],
    account,
    gasMultiplier: 5,
  });

  return receipt.transactionHash;
};

export const buyNarcs = async (
  account: string,
  types: number[],
  signMsg: string,
  signature: string
) => {
  const receipt = await writeContractAndWait({
    address,
    abi,
    functionName: "buyNarcs",
    args: [types, JSON.stringify(signMsg), signature],
    account,
    gasMultiplier: 5,
  });

  return receipt.transactionHash;
};

export const sellNarcs = async (
  account: string,
  itemIds: number[],
  signMsg: string,
  signature: string
) => {
  const receipt = await writeContractAndWait({
    address,
    abi,
    functionName: "sellNarcs",
    args: [itemIds, JSON.stringify(signMsg), signature],
    account,
    gasMultiplier: 5,
  });

  return receipt.transactionHash;
};

export const getBoozeSuccessRate = async (level: number) => {
  const successRate: number = await readContract({
    address,
    abi,
    functionName: "getBoozeSuccessRate",
    args: [level],
  });
  return successRate;
};

export const getNarcsSuccessRate = async (level: number) => {
  const successRate: number = await readContract({
    address,
    abi,
    functionName: "getNarcsSuccessRate",
    args: [level],
  });
  return successRate;
};

export const getNextBoozeTime = async (account: string) => {
  const nextBoozeTime: number = await readContract({
    address,
    abi,
    functionName: "nextBoozeTime",
    args: [account],
  });
  return Number(nextBoozeTime);
};

export const getNextNarcsTime = async (account: string) => {
  const nextNarcsTime: number = await readContract({
    address,
    abi,
    functionName: "nextNarcsTime",
    args: [account],
  });
  return Number(nextNarcsTime);
};

export const getAmountLimit = async (account: string) => {
  const amountLimit: any = await readContract({
    address,
    abi,
    functionName: "getAmountLimit",
    args: [account],
    account,
  });

  return [
    amountLimit.boozeLimit ?? amountLimit[0],
    amountLimit.narcsLimit ?? amountLimit[1],
  ].map((limit) => Number(limit));
};

export const claimBoozeProfit = async (account: string, cityId: number) => {
  const receipt = await writeContractAndWait({
    address,
    abi,
    functionName: "claimBoozeProfit",
    args: [cityId],
    account,
  });

  return receipt.transactionHash;
};

export const claimNarcsProfit = async (account: string, cityId: number) => {
  const receipt = await writeContractAndWait({
    address,
    abi,
    functionName: "claimNarcsProfit",
    args: [cityId],
    account,
  });

  return receipt.transactionHash;
};

export const getBoozeTotalProfit = async (city: number) => {
  const data = await readContract({
    address,
    abi,
    functionName: "cityBoozeProfit",
    args: [city],
  });
  return Number(formatEther(String(data)));
};

export const getNarcoTotalProfit = async (city: number) => {
  const data = await readContract({
    address,
    abi,
    functionName: "cityNarcsProfit",
    args: [city],
  });
  return Number(formatEther(String(data)));
};

export const sellWrappedBoozeUnits = async (
  account: string,
  itemIds: number[],
  signMsg: string,
  signature: string
) => {
  const receipt = await writeContractAndWait({
    address,
    abi,
    functionName: "sellWrappedBoozeUnits",
    args: [itemIds, JSON.stringify(signMsg), signature],
    account,
    gasMultiplier: 5,
  });

  return receipt.transactionHash;
};

export const sellWrappedNarcsUnits = async (
  account: string,
  itemIds: number[],
  signMsg: string,
  signature: string
) => {
  const receipt = await writeContractAndWait({
    address,
    abi,
    functionName: "sellWrappedNarcsUnits",
    args: [itemIds, JSON.stringify(signMsg), signature],
    account,
    gasMultiplier: 5,
  });

  return receipt.transactionHash;
};
